module.exports = __webpack_public_path__ + "components/flag/static/square/zw-47be5161baaa415eb2ab2645e5834657.svg";